module.exports = __webpack_public_path__ + "img/WEM.24d4fbc1.svg";